/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilePreviewComponent} from './file-preview.component';


@NgModule({
    declarations: [FilePreviewComponent],
    imports: [
        CommonModule
    ],
    exports: [FilePreviewComponent]
})

export class FilePreviewModule {
}
